require("./sitio");
require("bootstrap");
require("slick-carousel");
require("@fancyapps/fancybox");

// slide
import Splide from "@splidejs/splide";



let slide_destacados = new Splide("#slide-destacados", {
    type: "loop",
    perPage: 1,
    autoplay: false,
    arrows: true,
    pagination: false,
    interval: 10000,
}).mount();

setTimeout(function () {
    require("./components/FormularioAmigo");
    require("./modal_promocion");
}, 2000)


var slide_proyecto = $("#slide-incio").find('.contenido-inicio').slick({
    arrows: false,
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: false,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.prev-arrow'),
    nextArrow: $('.next-arrow'),

})




var slide_logos_proyecto = $("#slide-logos").find('.contenido-slide-logos').slick({
    centerMode: true,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $('.prev-arrow-logo'),
    nextArrow: $('.next-arrow-logo'),
    responsive: [
        {
            breakpoint: 990,
            settings: {
                slidesToShow: 2,
                centerMode: true
            }
        },
        {
            breakpoint: 540,
            settings: {
                slidesToShow: 1,
                centerMode: false
            }
        },
    ]
})

$('.contenido-slide-logos').find('.slick-center').find('.item').addClass('active');


slide_logos_proyecto.on('afterChange', function (event, slick, currentSlide, nextSlide) {
    $('.contenido-slide-logos').find('.slick-center').find('.item').addClass('active');
});
slide_logos_proyecto.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.contenido-slide-logos').find('.slick-center').find('.item').removeClass('active');
    slide_proyecto.slick('slickGoTo', nextSlide)

});

var slide_oportunidades = $("#slide-oportunidades-pr").find('.contenido-slide-oportunidades').slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
})